/** Canonical creator-circle tiers (amounts in CAD cents). */

export const TIER_ORDER = ["supporter", "inner", "vip"];

export const SUBSCRIPTION_TIERS = {
  supporter: {
    id: "supporter",
    name: "Supporter Circle",
    amountCents: 500,
    priceLabel: "$5",
    description: "Ongoing premium access, creator updates, and supporter perks.",
    features: [
      "All premium drops",
      "Creator updates",
      "Supporter badge on comments",
      "Access to supporter-only chats",
    ],
  },
  inner: {
    id: "inner",
    name: "Inner Circle",
    amountCents: 1000,
    priceLabel: "$10",
    recommended: true,
    description: "Premium drops, closer connection, and priority message access.",
    features: [
      "All Supporter benefits",
      "Priority message access",
      "Early drop notifications",
      "Exclusive behind-the-scenes content",
      "Monthly live Q&A",
    ],
  },
  vip: {
    id: "vip",
    name: "VIP",
    amountCents: 2000,
    priceLabel: "$20",
    description: "Everything, custom requests, and the deepest creator connection.",
    features: [
      "All Inner Circle benefits",
      "Custom content requests (1/month)",
      "Direct message access",
      "Exclusive VIP-only drops",
      "Annual gift box from creator",
    ],
  },
};

export function getTier(tierId) {
  return SUBSCRIPTION_TIERS[tierId] || null;
}

export function formatTierDollars(amountCents) {
  return `$${(Number(amountCents) / 100).toFixed(0)}`;
}

export function possessiveName(name) {
  const n = String(name || "").trim();
  if (!n) return "their";
  return /s$/i.test(n) ? `${n}'` : `${n}'s`;
}

const TIER_RANK = { supporter: 1, inner: 2, vip: 3 };

/** Normalize tier ids from Firestore (legacy names → canonical). */
export function normalizeTierId(tier) {
  if (!tier) return null;
  const t = String(tier).toLowerCase().trim();
  if (TIER_RANK[t]) return t;
  if (t.includes("vip")) return "vip";
  if (t.includes("inner")) return "inner";
  if (t.includes("support")) return "supporter";
  return t;
}

export function isTierHigherOrEqual(userTier, requiredTier) {
  const user = TIER_RANK[normalizeTierId(userTier)] || 0;
  const need = TIER_RANK[normalizeTierId(requiredTier)] || 0;
  if (!need) return Boolean(user);
  return user >= need;
}
